import { createContext } from 'react';

import { noop } from '@blockpulse3/data/shared';
import { UserInfosFragment } from '@blockpulse3/graphql/hooks';

export type IUserStatus = 'loading' | 'authenticated' | 'unauthenticated';
/**
 * IUserContext.
 *
 * User context type, providing the user data
 * and a setter
 */
export type IUserContext = {
  user: UserInfosFragment | null;
  status: IUserStatus;
  setStatus: React.Dispatch<React.SetStateAction<IUserStatus>>;
  loadUser: () => void;
};

export const UserContext = createContext<IUserContext>({
  user: null,
  status: 'loading',
  setStatus: noop,
  loadUser: noop,
});
